import nf from '@/constants/nf';
import { route } from '@/constants/routeName';
import { Paid, Person } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export default function UserHeader() {
	const user = useSelector((state) => state.auth.user);
	const selectedCustomer = useSelector((state) => state.auth.selectedCustomer);
	const selectedOutlet = useSelector((state) => state.auth.selectedOutlet);

	return (
		<div>
			<div className='flex gap-2 bg-bz-default'>
				<div className='relative h-16 border border-black w-14'>
					{user.avatar ? (
						<img src={user.avatar} alt={user.name} className='object-cover w-full h-full' />
					) : (
						<div className='w-full h-full text-[48px] flex'>
							<Person fontSize='inherit' className='m-auto' />
						</div>
					)}
				</div>
				<div className='flex justify-between w-full'>
					<div className='flex flex-col py-1 text-sm'>
						<span className='font-bold'>{user.name}</span>
						<span className='text-xs'>
							{selectedOutlet?.name}, {selectedCustomer?.member?.on_list_attributes?.class}
						</span>
						<div className='flex flex-1 w-full gap-2 space-between'>
							<span className={twMerge('text-xs font-bold', Math.sign(+selectedCustomer?.balance) < 0 ? 'text-red-500' : '')}>
								Deposit: {nf(+selectedCustomer?.balance || 0)}
							</span>
						</div>
					</div>
					<Link to={`/${route.accountTopUp}`} className='flex flex-col items-center justify-center gap-0 px-2 text-xs font-bold'>
						<Paid fontSize='medium' className='' /> Top up
					</Link>
				</div>
			</div>
		</div>
	);
}
